<template>
  <div class="game-buddy-list-container">
    <el-card class="list-card" shadow="hover">
      <div slot="header" class="clearfix">
        <span class="header-title">陪玩选手列表</span>
      </div>
      
      <div class="filter-container">
        <el-form :model="filterForm" inline>
          <el-form-item label="选手名称">
            <el-input v-model="filterForm.name" placeholder="请输入选手名称" style="width: 200px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searchGameBuddies">搜索</el-button>
            <el-button @click="resetFilter">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      
      <el-table :data="gameBuddies" style="width: 100%" stripe>
        <el-table-column prop="name" label="选手名称" width="150" align="center"></el-table-column>
        <el-table-column prop="expertise" label="特长" min-width="200">
          <template slot-scope="scope">
            <span class="expertise-tag" v-for="expertise in scope.row.expertise.split(',')" :key="expertise">
              {{ expertise }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="introduction" label="选手介绍" min-width="300">
          <template slot-scope="scope">
            <span>{{ scope.row.introduction || '暂无介绍' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="陪玩价格" width="150" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.price || 100 }}/小时</span>
          </template>
        </el-table-column>
        <el-table-column label="可陪玩时间" width="200" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.timeSlots && scope.row.timeSlots.length > 0">
              {{ formatTimeSlots(scope.row.timeSlots) }}
            </span>
            <span v-else style="color: #999;">未设置</span>
          </template>
        </el-table-column>
        <el-table-column label="预约" width="120" align="center">
          <template slot-scope="scope">
            <el-button type="primary" size="small" @click="showBookingDialog(scope.row)">
              预约
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          background
        ></el-pagination>
      </div>
    </el-card>
    
    <!-- 预约对话框 -->
    <el-dialog
      title="预约陪玩"
      :visible.sync="bookingDialogVisible"
      width="500px"
      center
    >
      <el-form :model="bookingForm" :rules="bookingRules" ref="bookingForm" label-width="100px">
        <el-form-item label="选手名称">
          <el-input v-model="selectedGameBuddy.name" disabled></el-input>
        </el-form-item>
        <el-form-item label="预约日期" prop="bookingDate">
          <el-date-picker
            v-model="bookingForm.bookingDate"
            type="date"
            placeholder="选择日期"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            style="width: 100%;"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="预约时间">
          <div class="time-range">
            <el-time-picker
              v-model="bookingForm.startTime"
              format="HH:mm"
              value-format="HH:mm"
              placeholder="开始时间"
              style="width: 45%;"
            ></el-time-picker>
            <span style="margin: 0 10px;">-</span>
            <el-time-picker
              v-model="bookingForm.endTime"
              format="HH:mm"
              value-format="HH:mm"
              placeholder="结束时间"
              style="width: 45%;"
            ></el-time-picker>
          </div>
        </el-form-item>
        <el-form-item label="备注" prop="note">
          <el-input
            v-model="bookingForm.note"
            type="textarea"
            :rows="3"
            placeholder="请输入备注（选填）"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="bookingDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitBooking">确定预约</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>

export default {
  name: 'GameBuddyList',
  data() {
    return {
      filterForm: {
        name: ''
      },
      gameBuddies: [],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      loading: false,
      bookingDialogVisible: false,
      selectedGameBuddy: {},
      bookingForm: {
        bookingDate: '',
        startTime: '',
        endTime: '',
        note: ''
      },
      bookingRules: {
        bookingDate: [
          { required: true, message: '请选择预约日期', trigger: 'change' }
        ]
      }
    }
  },
  mounted() {
    this.searchGameBuddies()
  },
  methods: {
    searchGameBuddies() {
      this.loading = true
      
      // 构造查询参数
      const params = {}
      if (this.filterForm.name) {
        params.expertise = this.filterForm.name  // 暂时复用expertise参数，后续可修改后端接口
      }
      
      this.$axios.get('/game-buddy/list', { params })
        .then(response => {
          if (response.data && response.data.data) {
            this.gameBuddies = response.data.data
            this.total = response.data.data.length
          } else {
            this.gameBuddies = response.data || []
            this.total = this.gameBuddies.length
          }
        })
        .catch(error => {
          this.$message.error('加载陪玩选手列表失败')
          console.error('Search game buddies error:', error)
        })
        .finally(() => {
          this.loading = false
        })
    },
    resetFilter() {
      this.filterForm = {
        name: ''
      }
      this.searchGameBuddies()
    },
    formatTimeSlots(timeSlots) {
      if (!timeSlots || timeSlots.length === 0) {
        return '未设置'
      }
      const slot = timeSlots[0]
      return `${slot.startTime}-${slot.endTime}`
    },
    showBookingDialog(gameBuddy) {
      this.selectedGameBuddy = gameBuddy
      this.bookingForm = {
        bookingDate: '',
        startTime: '',
        endTime: '',
        note: ''
      }
      this.bookingDialogVisible = true
    },
    submitBooking() {
      this.$refs.bookingForm.validate((valid) => {
        if (valid) {
          if (!this.bookingForm.startTime || !this.bookingForm.endTime) {
            this.$message.warning('请选择开始时间和结束时间')
            return
          }
          
          const bookingData = {
            gameBuddyId: this.selectedGameBuddy.id,
            bookingDate: this.bookingForm.bookingDate,
            startTime: this.bookingForm.startTime,
            endTime: this.bookingForm.endTime,
            note: this.bookingForm.note
          }
          
          this.$axios.post('/game-buddy/booking/create', bookingData)
            .then(res => {
              this.$message.success('预约成功！')
              this.bookingDialogVisible = false
            })
            .catch(error => {
              this.$message.error('预约失败，请稍后重试')
              console.error('Create booking error:', error)
            })
        }
      })
    },
    bookGameBuddy(gameBuddyId) {
      // 跳转到预约页面，传递陪玩选手ID
      this.$router.push({ path: '/game-buddy-booking', query: { gameBuddyId } })
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.searchGameBuddies()
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.searchGameBuddies()
    }
  }
}
</script>

<style scoped>
.game-buddy-list-container {
  padding: 20px 0;
}

.list-card {
  margin-bottom: 20px;
}

.header-title {
  font-size: 16px;
  font-weight: bold;
  color: #303133;
}

.filter-container {
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f5f7fa;
  border-radius: 4px;
}

.expertise-tag {
  display: inline-block;
  background-color: #ecf5ff;
  color: #409eff;
  padding: 2px 8px;
  border-radius: 10px;
  font-size: 12px;
  margin-right: 8px;
}

.introduction-text {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.5;
  max-height: 3em;
}

.pagination-container {
  text-align: right;
  margin-top: 20px;
}

.time-range {
  display: flex;
  align-items: center;
}
</style>
